import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceLine, VoiceScript } from "../voice-types.ts";

const sfx = (id: string, text: string): VoiceLine => ({
  id,
  text,
  engine: "sfx",
});

const script = {
  hero: HeroId.Geoff,
  voices: {},
  lines: {
    select: [sfx("select", "Mrrrr!")],
    spawn: [
      sfx("spawn_1", "Mrrrr!"),
      sfx("spawn_2", "Mrrrr…?"),
      sfx("spawn_3", "Mrrrr..."),
      sfx("spawn_4", "Mrrrr…"),
      sfx("spawn_5", "Mrrr!"),
      sfx("spawn_6", "MRRRR?"),
    ],
    respawn: [sfx("respawn", "Mrrrr!")],
    ult_ally: [sfx("ult_ally", "MRRRR!")],
    ult_enemy: [sfx("ult_enemy", "MRRRR!")],
    ability2: [sfx("ability2", "Mrrrr!")],
    ability1: [
      sfx("ability1_1", "Mrrrr!"),
      sfx("ability1_2", "Dun dun dun dun…"),
    ],
    kill: [sfx("kill", "Mrrrr!")],
    healed: [sfx("healed_1", "Yeah!"), sfx("healed_2", "Mrrrr!")],
  },
} satisfies VoiceScript;

export default script;
